/* 向内溶解 / 向外溶解 */
import { Canvas, dep, DisplayObject, Filter, getDefaults } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters, Action } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';

export default class DissolveFilter extends Filter {
    public static defaults: IAnimFilterOptions = {
        rate: 0,
        direction: PresetSubtype.Across,
        action: Action.ENTR,
    };

    @dep public rate: number;
    @dep public direction = PresetSubtype.UnSupport;
    @dep public action = Action.ENTR;

    public forbidWebgl = true;
    public type = AnimFilters.DISSOLVE;
    // 使用 action 避免在动画面板中更新属性后线条缺失无法覆盖整个元素区域
    protected dotsCache: Map<string, number[][]>;
    protected sizeCache: Map<string, number>;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super();
        const defaults = getDefaults<typeof DissolveFilter>(this);
        this.rate = options.rate ?? defaults.rate;
        this.direction = options.direction ?? defaults.direction;
        this.action = options.action ?? defaults.action;
        this.dotsCache = new Map();
        this.sizeCache = new Map();
    }

    public apply(obj: DisplayObject, canvas: Canvas) {
        const size = this.updateSize(canvas);
        const dots = this.genDots(canvas);
        const range = this.rate * dots.length;
        const renderDots = this.isEntr() ? dots.slice(range, dots.length) : dots.slice(0, range);
        renderDots.forEach(([x, y]) => {
            canvas.clearRect(x, y, size, size);
        });
    }

    protected genDots = (canvas: Canvas): number[][] => {
        const { width, height, bounds } = canvas;
        const key = `${this.action}-${width}-${height}`;
        const cacheDots = this.dotsCache.get(key);
        if (cacheDots) return cacheDots;
        const size = this.sizeCache.get(key) || 1;
        const { x: canvasX, y: canvasY } = bounds;

        const dots: number[][] = [];
        for (let x = 0; x < width; x += size) {
            for (let y = 0; y < height; y += size) {
                dots.push([x + canvasX, y + canvasY]);
            }
        }
        for (let i = dots.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [dots[i], dots[j]] = [dots[j], dots[i]];
        }

        this.dotsCache.set(key, dots);
        return dots;
    };

    protected updateSize = (canvas) => {
        const { width, height } = canvas;
        const key = `${this.action}-${width}-${height}`;
        const size = this.sizeCache.get(key);
        if (size) return size;
        const canvasPixel = width * height;
        const newSize = `${Math.floor(canvasPixel / 10000)}`.length || 1;
        this.sizeCache.set(key, newSize);
        return newSize;
    };


    protected  isEntr = () => this.action === Action.ENTR;
}
